<h2 class="comp-title">Table</h2>

<mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
</mat-form-field>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

        <!-- ID Column -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ת.עסקה </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="progress">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> שם בית עסק </th>
            <td mat-cell *matCellDef="let row"> {{row.progress}}% </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> סוג עסקה </th>
            <td mat-cell *matCellDef="let row"> {{row.name}} </td>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="color">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> סכום </th>
            <td mat-cell *matCellDef="let row" [style.color]="row.color"> {{row.color}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>

    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
</div>


